/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/*
mutation UnassignPersonFromTaskMutation(
  $input: UnassignPersonFromTaskInput!
) {
  unassignPersonFromTask(input: $input) {
    task {
      id
      assignedPersons {
        id
      }
    }
  }
}
*/
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input",
            "type": "UnassignPersonFromTaskInput!"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v2 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UnassignPersonFromTaskPayload",
            "kind": "LinkedField",
            "name": "unassignPersonFromTask",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "assignedPersons",
                            "plural": true,
                            "selections": [
                                (v1 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UnassignPersonFromTaskMutation",
            "selections": (v2 /*: any*/),
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UnassignPersonFromTaskMutation",
            "selections": (v2 /*: any*/)
        },
        "params": {
            "id": null,
            "metadata": {},
            "name": "UnassignPersonFromTaskMutation",
            "operationKind": "mutation",
            "text": "mutation UnassignPersonFromTaskMutation(\n  $input: UnassignPersonFromTaskInput!\n) {\n  unassignPersonFromTask(input: $input) {\n    task {\n      id\n      assignedPersons {\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = 'b7bd1a0ab627edb2dfe128c1a51cba8e';
export default node;
